import styled, { css } from 'styled-components';

const Container = styled.label `
  ${props => {
    if (props.$disabled) {
        return css `
        cursor: not-allowed;
      `;
    }
    return css `
      cursor: pointer;
    `;
}}

  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
`;
const Children = styled.span `
  font-family: ${props => props.theme.fonts.museo};
  font-size: 14px;
  line-height: ${props => (props.$size === 'small' ? '16px' : 1.25)};
  color: ${props => props.$disabled ? props.theme.colors.gray400 : props.theme.colors.gray900};
`;

export { Children, Container };
//# sourceMappingURL=styled.js.map
